import React, { useState, useEffect,useRef } from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Divider,
  useMediaQuery,
  IconButton,
  CircularProgress
} from '@mui/material';
import {
    LocalMall as CementBagIcon,

  Construction as ConstructionIcon,
  AcUnit as SteelIcon,
  Square as BrickIcon,
  Grain as SandIcon,
  Terrain as StoneIcon,
  Window as WoodWindowsIcon,
  Bolt as ElectricalIcon,
  Build as FabricationIcon,
  Plumbing as PlumbingIcon,
  GridOn as TilesGraniteIcon,
  FormatPaint as PaintIcon,
  DoorFront as DoorsIcon,
    KeyboardArrowUp,
  KeyboardArrowDown
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link } from 'react-router-dom';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import property_pincode_new from './../../../Images/property_pincode_new.png';
import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';
import { Modal, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Elevationconstruction from './../../../Assets/Elevationconstruction.png';


const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const ExploreConstructionResources = () => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [showScrollUp, setShowScrollUp] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true);
    const listRef = useRef(null);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState('');
    const [open, setOpen] = React.useState(false);
     const location = useLocation();


  const drawerWidth = '15%';

  // Default categories with icons (fallback if API fails)
  const defaultCategories = [
    { category_id: 1, category: 'Cement' },
    { category_id: 2, category: 'Steel' },
    { category_id: 3, category: 'Brick' },
    { category_id: 4, category: 'Sand' },
    { category_id: 5, category: 'Stone' },
    { category_id: 6, category: 'Windows and Doors' },
    { category_id: 7, category: 'Electrical' },
    { category_id: 8, category: 'Fabrication' },
    { category_id: 9, category: 'Plumbing' },
    { category_id: 10, category: 'Tiles and Granite' },
    { category_id: 11, category: 'Paint' }
  ];
  // Handle scroll events
  const handleScroll = () => {
    if (listRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      setShowScrollUp(scrollTop > 0);
      setShowScrollDown(scrollTop < scrollHeight - clientHeight);
    }
  };

  // Scroll functions
  const scrollUp = () => {
    if (listRef.current) {
      listRef.current.scrollBy({ top: -100, behavior: 'smooth' });
    }
  };

  const scrollDown = () => {
    if (listRef.current) {
      listRef.current.scrollBy({ top: 100, behavior: 'smooth' });
    }
  };


  // Fetch categories and materials
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch categories from API
        const categoriesResponse = await axios.get(`${BASE_URL}/material-categories/`);
        const fetchedCategories = categoriesResponse.data.length > 0 ? 
          categoriesResponse.data : defaultCategories;
        
        setCategories(fetchedCategories);
        
        // Set the first category as active by default
        if (fetchedCategories.length > 0) {
          setActiveCategory(fetchedCategories[0].category_id);
          await fetchMaterials(fetchedCategories[0].category_id);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
        // Fallback to default categories if API fails
        setCategories(defaultCategories);
        if (defaultCategories.length > 0) {
          setActiveCategory(defaultCategories[0].category_id);
          fetchMaterials(defaultCategories[0].category_id);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Fetch materials when active category changes
  useEffect(() => {
    if (activeCategory) {
      fetchMaterials(activeCategory);
    }
  }, [activeCategory]);

  const fetchMaterials = async (categoryId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/material-content/`);
      const filteredMaterials = response.data
        .filter(item => item.category_id == categoryId)
        .map(item => ({
          id: item.content_id,
          title: item.content,
          imageUrl: `${BASE_URL}${item.image}`
        }));
      setMaterials(filteredMaterials);
    } catch (error) {
      console.error('Error fetching materials:', error);
    } finally {
      setLoading(false);
    }
  };

  const getCategoryIcon = (categoryName) => {
    // Convert to lowercase and remove any extra spaces for consistent matching
    const normalizedCategory = categoryName.toLowerCase().trim();
    
    switch (normalizedCategory) {
      case 'cement':
        return <CementBagIcon  />;
      case 'steel':
        return <SteelIcon />;
      case 'bricks':
        return <BrickIcon />;
      case 'sand':
        return <SandIcon />;
      case 'stone':
        return <StoneIcon />;
      case 'windows and doors':
        return <DoorsIcon />;
      case 'electrical':
        return <ElectricalIcon />;
      case 'fabrication':
        return <FabricationIcon />;
      case 'plumbing':
        return <PlumbingIcon />;
      case 'tiles and granite':
      case 'tiles and granite':
        return <TilesGraniteIcon />;
      case 'paint':
        return <PaintIcon />;
      default:
        return <ConstructionIcon />;
    }
  };

  const rows = chunkArray(materials, 2);

  return (
    <>
      {/* Sticky Header Section */}
    <Box sx={{
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1200,
  bgcolor: 'background.paper',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
}}>
        {/* Top Navigation Bar */}
        <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{
          background: 'black',
          borderBottom: '1px solid rgba(0,0,0,0.08)'
        }}>
          {/* Back Arrow - Left Side */}
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              color: 'white',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>

          {/* Center Text - "landnest" */}
          <Typography variant="h7" component="div" sx={{
            color: 'white',
            fontWeight: 'bold',
            flexGrow: 1,
            textAlign: 'left'
          }}>
            PROPERTY PINCODER
          </Typography>

          {/* Right Side Logo */}
          <Box sx={{
            width: 90,
            height: 50,
                boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img
              src={property_pincode_new}
              alt="property_pincode_new Logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Box>

        {/* Construction/Interior Navigation */}
      <Box sx={{
  padding: isMobile ? 1 : 0.5,
  display: 'flex',
  justifyContent: 'space-between',
  boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
}}>
  {/* Construction - Active */}
  <Box
    component={Link}
    to="/constructions"
    sx={{
      flex: 1,
      textAlign: 'center',
      py: 2,
      textDecoration: 'none',
      position: 'relative',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url(${Elevationconstruction})
      `,
      backgroundBlendMode: 'overlay',
      borderRight: '1px solid rgba(0,0,0,0.1)',
      borderTopLeftRadius: '30px',
      boxShadow: `
        inset 0 0 15px rgba(0,0,0,0.2),
        0 4px 10px rgba(0,0,0,0.15)
      `,
      transform: 'scale(1.02)',
      transition: 'all 0.3s ease',
      zIndex: 1,
      '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: `
          inset 0 0 20px rgba(0,0,0,0.15),
          0 5px 12px rgba(0,0,0,0.18)
        `,
        '&::after': {
          width: '70%',
          backgroundColor: '#333333',
        }
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '70%',
        height: '3px',
        backgroundColor: '#333333',
        borderRadius: '3px',
        transition: 'all 0.3s ease',
      }
    }}>
    <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
      fontWeight: 800,
      color: '#333333',
      textShadow: '0 1px 3px rgba(255,255,255,0.5)',
      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
      transform: 'scale(1.05)',
      transition: 'transform 0.3s ease',
    }}>
      Constructions
    </Typography>
  </Box>

  {/* Interiors - Inactive */}
  <Box
    component={Link}
    to="/interiors"
    sx={{
      flex: 1,
      textAlign: 'center',
      py: 2,
      position: 'relative',
      background: `
        linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
        url('/construction5.png')
      `,
      backgroundBlendMode: 'overlay',
      textDecoration: 'none',
      borderBottomRightRadius: '30px',
      boxShadow: `
        inset 0 0 15px rgba(0,0,0,0.2),
        0 2px 5px rgba(0,0,0,0.1)
      `,
      transform: 'scale(0.98)',
      transition: 'all 0.3s ease',
      '&:hover': {
        background: `
          linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
          url('/construction5.png')
        `,
        transform: 'scale(1)',
        boxShadow: `
          inset 0 0 20px rgba(0,0,0,0.3),
          0 3px 8px rgba(0,0,0,0.2)
        `,
        '&::after': {
          width: '70%',
          backgroundColor: 'rgba(255,255,255,0.9)',
        }
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '0%',
        height: '3px',
        backgroundColor: 'transparent',
        borderRadius: '3px',
        transition: 'all 0.3s ease',
      }
    }}
  >
    <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
      fontWeight: 700,
      color: 'rgba(255,255,255,0.9)',
      letterSpacing: '1px',
      textShadow: '0 1px 5px rgba(0,0,0,0.7)',
      fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
      transform: 'scale(1)',
      transition: 'transform 0.3s ease',
    }}>
      Interiors
    </Typography>
  </Box>
</Box>
      </Box>

      <Box sx={{ 
  display: 'flex', 
  height: 'calc(100vh - 112px)', 
  overflow: 'hidden',
  mt: isMobile ? '140px' : '120px', // ADD THIS LINE - adjust values as needed
}}>
        <Drawer
          variant="permanent"
          anchor="left"
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                backgroundColor: '#e7dbc9',
                borderRight: 'none',
                borderTopLeftRadius: '18px',
                borderBottomRightRadius: '18px',
                marginTop: '155px',
                height: '70vh',
                marginLeft: '1px',
                border: '1px solid black',
              },
            }}
        >

          {showScrollUp && (
            <IconButton 
              onClick={scrollUp}
              sx={{
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1,
                backgroundColor: 'rgba(20, 18, 18, 0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.3)',
                }
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
          )}
          {loading && categories.length == 0 ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <CircularProgress />
            </Box>
          ) : (
            <List 
              dense 
              sx={{ p: 0, overflowY: 'auto' }} 
              ref={listRef}
              onScroll={handleScroll}
            >
              {categories.map((category) => {
                const isSelected = activeCategory == category.category_id;

                return (
                  <React.Fragment key={category.category_id}>
                    <ListItem
                      button
                      selected={isSelected}
                      onClick={() => setActiveCategory(category.category_id)}
                      sx={{
                        py: 1.5,
                        flexDirection: 'column',
                        backgroundColor: isSelected ? 'black' : 'transparent',
                        color: isSelected ? 'white' : 'rgba(5, 4, 4, 0.7)',
                        '&:hover': {
                          backgroundColor: isSelected ? 'black' : '#e3f2fd',
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 'auto',
                          justifyContent: 'center',
                          color: isSelected ? 'white' : 'rgba(5, 4, 4, 0.7)',
                          '& svg': {
                            fontSize: '1.5rem',
                          },
                        }}
                      >
                        {getCategoryIcon(category.category)}
                      </ListItemIcon>

                      <ListItemText
                        primary={category.category}
                        primaryTypographyProps={{
                          fontSize: '0.7rem',
                          textAlign: 'center',
                          fontWeight: isSelected ? '600' : '400',
                          color: isSelected ? '#ffffff' : 'rgba(10, 10, 10, 0.9)',
                        }}
                        sx={{
                          marginTop: '4px',
                          '& .MuiTypography-root': {
                            display: 'block',
                          },
                        }}
                      />
                    </ListItem>
                    <Divider sx={{ backgroundColor: 'rgba(9, 9, 9, 0.2)' }} />
                  </React.Fragment>
                );
              })}
            </List>
          )}
           {showScrollDown && (
            <IconButton 
              onClick={scrollDown}
              sx={{
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1,
                backgroundColor: 'rgba(0,0,0,0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.3)',
                }
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          )}
        </Drawer>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            bgcolor: '#fff',
            pt: 2,
            pb: 10
          }}
        >
          <Typography variant="body1" align="center" sx={{ mb: 2, fontWeight: 500 }}>
            Explore Construction Resources
          </Typography>

          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
              <CircularProgress />
            </Box>
          ) : (
            <Box display="flex" flexDirection="column" gap={1} marginBottom='20px'>
              {rows.length > 0 ? (
                rows.map((row, rowIndex) => (
                  <Box key={rowIndex} display="flex" gap={1} padding={1}>
                    {row.map((item) => (
                      <Card
                        key={item.id}
                        
                        onClick={() => {
                          setSelectedItemId(item.id);
                          setOpen(true); // open modal on card click
                        }}
                        sx={{
                          width: '100%',
                          borderRadius: 2,
                          border: '0.5px solid #000',
                          boxShadow: selectedItemId == item.id ? 6 : 2,
                          cursor: 'pointer',
                          transition: '0.2s',
                          overflow: 'hidden',
                          height: '135px',
                        }}
                      >
                        <CardMedia
                          component="img"
                          image={item.imageUrl}
                          alt={item.title}
                          sx={{ height: 100, objectFit: 'cover' }}
                        />
                     <CardContent sx={{ padding: 1 }}>
  <Typography
    variant="body2"
    align="center"
    fontWeight="500"
    sx={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    {item.title}
  </Typography>
</CardContent>

                      </Card>
                    ))}
                  </Box>
                ))
              ) : (
                <Typography variant="body1" align="center" sx={{ mt: 4 }}>
                  No materials found for this category
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Box>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',                         // 80% width for all screens
            maxHeight: isMobile ? '80vh' : 500,
            overflowY: 'auto',
            bgcolor: 'background.paper',
            borderRadius: 4,                      // consistent border radius
            boxShadow: 24,
            p: 3,
          }}
        >
          {selectedItemId && (
            <>
              <Typography
                variant="h6"
                gutterBottom
                align="center"
                sx={{ fontWeight: 700 }}           // bold and centered title
              >
                {materials.find((item) => item.id === selectedItemId)?.title}
              </Typography>
              <img
                src={materials.find((item) => item.id === selectedItemId)?.imageUrl}
                alt="Selected"
                style={{
                  width: '100%',
                  maxHeight: isMobile ? 200 : 250,
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${BASE_URL}/media/default.jpg`;
                }}
              />
            </>
          )}
        </Box>
      </Modal>
      <FormsBottomNavbar />
       <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="md">
              <Box p={2} textAlign="center">
                <Typography variant="h6" gutterBottom>{selectedTitle}</Typography>
                   <IconButton
      onClick={() => setOpen(false)}
      sx={{ position: 'absolute', top: 8, right: 8 }}
      aria-label="close"
    >
      <CloseIcon />
    </IconButton>
                <img
                  src={selectedImage}
                  alt="Selected Plan"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }}
                />
              </Box>
            </Dialog>
      
    </>
  );
};

export default ExploreConstructionResources;